import { Accordion, Box, Typography } from "@compass/core";
import { ReactNode } from "react";

interface FilterAccordionProps {
  title: string;
  children: ReactNode;
  defaultExpanded?: boolean;
}

export const FilterAccordion = (props: FilterAccordionProps) => {
  return (
    <Accordion
      label={
        <Typography fontWeight={600}>
          {props.title}
        </Typography>
      }
      defaultExpanded={props.defaultExpanded}
    >
      <Box sx={{ px: 2, pb: 2 }}>
        {props.children}
      </Box>
    </Accordion>
  );
};
